import { ERROR_MESSAGE, NEW_USER_TEMP_SHARE_DISTRIBUTOR, PAGE_PATH } from '@/constants';
import { fetchBoundDistributor, fetchDesCode } from '@/services';
import { useAppStore, useSearchStore } from '@/store';
import { nextTick } from 'vue';
import { storage } from '../storage';
import { toast } from '../toast';

export default {
  shoppingCreditsDeduction: (shoppingCreditsDeductionId: string, extraParam?: any) => {
    console.log('<购物金抵扣页>');
    const base = `${PAGE_PATH.shoppingCreditsDeduction.route}?id=${shoppingCreditsDeductionId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  shoppingCreditsClaim: (shoppingCreditsClaimId: string, extraParam?: any) => {
    console.log('<购物金可得页>');
    const base = `${PAGE_PATH.shoppingCreditsClaim.route}?id=${shoppingCreditsClaimId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  forumTag: (topicId: string) => {
    console.log('<论坛话题页>');
    uni.navigateTo({
      url: `${PAGE_PATH.forumTopicDetail.route}?id=${topicId}`,
    });
  },
  forum: () => {
    console.log('<论坛页>');
    uni.navigateTo({
      url: `${PAGE_PATH.forumList.route}`,
    });
  },
  // 积分商城
  pointsMall: () => {
    console.log('<积分商城页>');
    uni.navigateTo({
      url: `${PAGE_PATH.integralCommodity.route}`,
    });
  },
  blindBoxActivity: (customPageId: string) => {
    console.log('<盲盒活动页>');
    uni.navigateTo({
      url: `${PAGE_PATH.blindBoxActivity.route}?id=${customPageId}`,
    });
  },
  coupon: (couponId: string) => {
    console.log('<优惠券页>');
    uni.navigateTo({
      url: `${PAGE_PATH.couponDetail.route}?couponId=${couponId}&entry=without`,
    });
  },
  couponBundle: (couponBundleId: string) => {
    console.log('<优惠券礼包页>');
    uni.navigateTo({
      url: `${PAGE_PATH.couponGiftpack.route}?couponBundleId=${couponBundleId}`,
    });
  },
  customPage: (customPageId: string) => {
    console.log('<自定义-活动页>');
    uni.navigateTo({
      url: `${PAGE_PATH.activity.route}?id=${customPageId}`,
    });
  },
  checkinPage: (customPageId: string) => {
    console.log('<自定义-签到页>');
    uni.navigateTo({
      url: `${PAGE_PATH.signIn.route}?id=${customPageId}`,
    });
  },
  homePage: () => {
    console.log('<自定义-首页>');
    uni.navigateTo({ url: `${PAGE_PATH.home.route}` });
  },
  commodityGroupPage: () => {
    console.log('<自定义-商品分组页>');
    uni.navigateTo({ url: `${PAGE_PATH.classify.route}` });
  },
  memberCenterPage: () => {
    console.log('<自定义-会员中心页>');
    uni.navigateTo({ url: `${PAGE_PATH.member.route}` });
  },
  memberShipPlan: (memberShipPlanId: string) => {
    if (memberShipPlanId) {
      // 会员详情
      uni.navigateTo({
        url: `${PAGE_PATH.memberDetail.route}?memberShipPlanId=${memberShipPlanId}`,
      });
    } else {
      // 会员列表
      uni.navigateTo({ url: PAGE_PATH.memberDetail.route });
    }
  },
  product: (productId: string) => {
    console.log('<商品详情页>');
    uni.navigateTo({
      url: `${PAGE_PATH.commodity.route}?id=${productId}`,
    });
  },
  purchasePremium: (purchasePremiumId: string, extraParam?: any) => {
    console.log('<加价购活动页>');
    const base = `${PAGE_PATH.purchasePremium.route}?id=${purchasePremiumId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  discountActivity: (discountActivityId: string, extraParam?: any) => {
    console.log('<第二件半价活动页>');
    const base = `${PAGE_PATH.halfDiscount.route}?id=${discountActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  fullDiscountActivity: (fullDiscountActivityId: string, extraParam?: any) => {
    console.log('<满减送活动页>');
    const base = `${PAGE_PATH.fulfilPresent.route}?id=${fullDiscountActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  selectiveGiftActivity: (selectiveGiftActivityId: string, extraParam?: any) => {
    console.log('<任选满赠活动页>');
    const base = `${PAGE_PATH.selectiveGift.route}?id=${selectiveGiftActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  packageDiscount: (fullDiscountActivityId: string, extraParam?: any) => {
    console.log('<打包一口价活动页>');
    const base = `${PAGE_PATH.packageDiscount.route}?id=${fullDiscountActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  shoppingCreditsClaimActivity: (shoppingCreditsClaimActivityId: string, extraParam?: any) => {
    console.log('<购物金活动页>');
    const base = `${PAGE_PATH.shoppingCreditsClaim.route}?id=${shoppingCreditsClaimActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  shoppingCreditsDeductionActivity: (
    shoppingCreditsDeductionActivityId: string,
    extraParam?: any
  ) => {
    console.log('<购物金抵扣活动页>');
    const base = `${PAGE_PATH.shoppingCreditsDeduction.route}?id=${shoppingCreditsDeductionActivityId}`;
    const url = extraParam ? `${base}&extra=${extraParam}` : base;
    uni.navigateTo({ url });
  },
  distribution: async (distributorId?: string) => {
    let _distributorId = distributorId || useAppStore().shareDistributorData?.distributorId || '';

    // 判断本地是否有新用户分销信息缓存
    const newUserCache = storage.get(NEW_USER_TEMP_SHARE_DISTRIBUTOR);
    if (newUserCache) {
      _distributorId = newUserCache.distributorId;
      storage.remove(NEW_USER_TEMP_SHARE_DISTRIBUTOR);
    }

    if (!_distributorId) {
      console.log('<分销员id不存在>');
      return;
    }

    console.log('<分销员id>', _distributorId);

    const res = await fetchBoundDistributor(_distributorId);

    console.log(`<分销绑定结果>`, res);
  },
  miniProgram: (path: string = '') => {
    console.log('<跳转其他小程序>');
    // #ifdef MP-WEIXIN
    uni.navigateToMiniProgram({
      appId: 'wx9076f9fa47df70f1',
      path,
      // extraData: { data1: 'test' },
      success() {
        // 返回成功
      },
      fail() {
        toast.message(ERROR_MESSAGE.routeMp);
      },
    });
    // #endif
  },
  giftCard: (giftCardId: string) => {
    console.log('<礼品卡页>');
    if (!giftCardId) {
      console.log('<礼品卡参数不存在>', giftCardId);
      return;
    }
    uni.navigateTo({
      url: `${PAGE_PATH.memberGiftCard.route}?id=${giftCardId}`,
    });
  },
  /**
   * 解析分享分销跳转进来的字符串值
   * @param scene
   * @returns
   */
  parseOptionsQueryScene: async (scene: string) => {
    try {
      const data = await fetchDesCode(scene);
      if (data) {
        return data;
      } else {
        console.log(`<options.query.scene 解析失败>`, data);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  },
  /**
   * 搜索结果
   * @param searchValue
   */
  searchResult: async (searchValue: string) => {
    console.log('<搜索结果页>');
    const searchStore = useSearchStore();
    searchStore.searchValue = searchValue;
    await nextTick();
    setTimeout(() => {
      uni.navigateTo({ url: PAGE_PATH.searchResult.route });
    }, 100);
  },
  search: () => {
    console.log('<搜索页>');
    uni.navigateTo({
      url: `${PAGE_PATH.search.route}`,
    });
  },
};
